import BdcBilling from "../components/Bdc/Billing";

const BdcBillingsPage = () => <BdcBilling />;

export default BdcBillingsPage;
